import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import useWindowDimensions from "../../hooks/useWindowsDimensions";
import { leads } from "../../redux/leads/action";
import { cargoLeads } from "../../redux/cargo-lead/action";
import { useAppDispatch } from "../../hooks/hooks";
import { settings } from "../../redux/settings/actions";

const CustomerFooter = () => {
	const dispatch = useAppDispatch();
	let navigate = useNavigate()
	const [isOpen, setIsOpen] = useState(false);
	const dropdownRef = useRef(null);
	const { height, width } = useWindowDimensions();
	const toggleDropdown = () => {
		setIsOpen(!isOpen);
	};
	const handleClickOutside = (event: any) => {
		if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
			setIsOpen(false);
		}
	};
	const handleHomeClick = () => {
		navigate('/customer/home')
		setIsOpen(false);
	}
	const handleBookingClick = () => {
		navigate('/customer/bookings')
		setIsOpen(false);
	}
	const handleEnquiriesClick = () => {
		navigate('/customer/logistics/transport/leads')
		setIsOpen(false);
	}

	const handleTrackOrderClick = () => {
		navigate('/customer/track/order')
		setIsOpen(false);
	}
	const handleQuotesClick = () => {
		navigate('/customer/logistics/transport/logistics-quotes')
		setIsOpen(false);
	};
	const handleOrderClick = () => {
		navigate('/customer/logistics/transport/shipments')
		setIsOpen(false);
	}
	const themeValue = localStorage.getItem("theme");
	const handleLogout = () => {
		dispatch(settings.set({
			theme: themeValue,
		}))
		dispatch(leads.resetAction({ actionType: 'create' }))
		dispatch(cargoLeads.resetAction({ actionType: 'create' }))
		localStorage.removeItem('access-token')
		localStorage.removeItem('accessTokenMetadata')
		localStorage.removeItem('userProfile')
		localStorage.removeItem('google-login-role')
		navigate('/auth/login/customer')
	}
	useEffect(() => {
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);
	return (
		<>{width && width < 720 ? //  Start - Mobile View
			<>
				<footer className={`max-h-screen fixed -bottom-1 z-[200] w-screen bg-primary text-white h-20`}>
					<ul className="flex flex-row justify-around items-center w-full p-3">
						<li className=" flex flex-col items-center justify-center space-y-2" onClick={() => handleHomeClick()}>
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="white" fill="none">
								<path d="M12 17H12.009" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
								<path d="M20 8.5V13.5C20 17.2712 20 19.1569 18.8284 20.3284C17.6569 21.5 15.7712 21.5 12 21.5C8.22876 21.5 6.34315 21.5 5.17157 20.3284C4 19.1569 4 17.2712 4 13.5V8.5" stroke="currentColor" stroke-width="2" />
								<path d="M22 10.5L17.6569 6.33548C14.9902 3.77849 13.6569 2.5 12 2.5C10.3431 2.5 9.00981 3.77849 6.34315 6.33548L2 10.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
							</svg>
							<span className="text-light hover:text-[#FFB934] text-xs">Home</span>
						</li>
						<li className="flex flex-col items-center justify-center space-y-2" onClick={() => handleQuotesClick()}>
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#ffffff" fill="none">
								<path d="M8 13.5H16M8 8.5H12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
								<path d="M6.09881 19C4.7987 18.8721 3.82475 18.4816 3.17157 17.8284C2 16.6569 2 14.7712 2 11V10.5C2 6.72876 2 4.84315 3.17157 3.67157C4.34315 2.5 6.22876 2.5 10 2.5H14C17.7712 2.5 19.6569 2.5 20.8284 3.67157C22 4.84315 22 6.72876 22 10.5V11C22 14.7712 22 16.6569 20.8284 17.8284C19.6569 19 17.7712 19 14 19C13.4395 19.0125 12.9931 19.0551 12.5546 19.155C11.3562 19.4309 10.2465 20.0441 9.14987 20.5789C7.58729 21.3408 6.806 21.7218 6.31569 21.3651C5.37769 20.6665 6.29454 18.5019 6.5 17.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
							</svg>
							<span className="text-light hover:text-[#FFB934] text-xs">Quotes</span>
						</li>
						<li onClick={() => handleBookingClick()}
							className=" flex flex-col items-center justify-center space-y-2 ">
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#ffffff" fill="none">
								<path d="M18 2V4M6 2V4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
								<path d="M11.05 22C7.01949 22 5.00424 22 3.75212 20.6464C2.5 19.2927 2.5 17.1141 2.5 12.7568V12.2432C2.5 7.88594 2.5 5.70728 3.75212 4.35364C5.00424 3 7.01949 3 11.05 3H12.95C16.9805 3 18.9958 3 20.2479 4.35364C21.4765 5.68186 21.4996 7.80438 21.5 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
								<path d="M3 8H21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
								<path d="M13 18H21M17 14L17 22" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
							</svg>
							<span className="text-light hover:text-[#FFB934] text-xs">Bookings</span>
						</li>
						<li className="flex flex-col items-center justify-center space-y-2" onClick={() => handleOrderClick()}>
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#ffffff" fill="none">
								<path d="M7.99805 16H11.998M7.99805 11H15.998" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
								<path d="M7.5 3.5C5.9442 3.54667 5.01661 3.71984 4.37477 4.36227C3.49609 5.24177 3.49609 6.6573 3.49609 9.48836L3.49609 15.9944C3.49609 18.8255 3.49609 20.241 4.37477 21.1205C5.25345 22 6.66767 22 9.49609 22L14.4961 22C17.3245 22 18.7387 22 19.6174 21.1205C20.4961 20.241 20.4961 18.8255 20.4961 15.9944V9.48836C20.4961 6.6573 20.4961 5.24177 19.6174 4.36228C18.9756 3.71984 18.048 3.54667 16.4922 3.5" stroke="currentColor" stroke-width="1.5" />
								<path d="M7.49609 3.75C7.49609 2.7835 8.2796 2 9.24609 2H14.7461C15.7126 2 16.4961 2.7835 16.4961 3.75C16.4961 4.7165 15.7126 5.5 14.7461 5.5H9.24609C8.2796 5.5 7.49609 4.7165 7.49609 3.75Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
							</svg>
							<span className="text-light hover:text-[#FFB934] text-xs">Orders</span>
						</li>
						<li className="flex flex-col items-center justify-center space-y-2" onClick={() => toggleDropdown()}>
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="white" fill="none">
								<path d="M21 12C21 11.1716 20.3284 10.5 19.5 10.5C18.6716 10.5 18 11.1716 18 12C18 12.8284 18.6716 13.5 19.5 13.5C20.3284 13.5 21 12.8284 21 12Z" stroke="currentColor" stroke-width="1.5" />
								<path d="M13.5 12C13.5 11.1716 12.8284 10.5 12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5C12.8284 13.5 13.5 12.8284 13.5 12Z" stroke="currentColor" stroke-width="1.5" />
								<path d="M6 12C6 11.1716 5.32843 10.5 4.5 10.5C3.67157 10.5 3 11.1716 3 12C3 12.8284 3.67157 13.5 4.5 13.5C5.32843 13.5 6 12.8284 6 12Z" stroke="currentColor" stroke-width="1.5" />
							</svg>
							<span className="text-light hover:text-[#FFB934] text-xs">More</span>
						</li>
					</ul>
				</footer>
				{isOpen && (

					<div className={`bg-primary z-10 fixed bottom-20 left-0 right-0 m-1 -mb-0 rounded-t-md border-2 shadow-lg p-4`}>
						<div className="grid grid-cols-3 gap-4 w-full max-w-md mx-auto" >
							<div className="flex flex-col justufy-between items-center w-full space-y-2 cursor-pointer border rounded p-4 bg-secondary" onClick={() => handleEnquiriesClick()}>
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="28" height="28" color="#ffffff" fill="none">
									<path d="M22 11.5667C22 16.8499 17.5222 21.1334 12 21.1334C11.3507 21.1343 10.7032 21.0742 10.0654 20.9545C9.60633 20.8682 9.37678 20.8251 9.21653 20.8496C9.05627 20.8741 8.82918 20.9948 8.37499 21.2364C7.09014 21.9197 5.59195 22.161 4.15111 21.893C4.69874 21.2194 5.07275 20.4112 5.23778 19.5448C5.33778 19.0148 5.09 18.5 4.71889 18.1231C3.03333 16.4115 2 14.1051 2 11.5667C2 6.28357 6.47778 2 12 2C17.5222 2 22 6.28357 22 11.5667Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
									<path d="M10 9.84615C10 8.82655 10.8954 8 12 8C13.1046 8 14 8.82655 14 9.84615C14 10.2137 13.8837 10.5561 13.6831 10.8438C13.0854 11.7012 12 12.5189 12 13.5385V14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
									<path d="M12 16.5H12.009" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
								</svg>
								<span className="text-light hover:text-[#FFB934] capitalize text-sm text-center">Enquiries</span>
							</div>
							<div className="flex flex-col justufy-between items-center w-full space-y-2 cursor-pointer border rounded p-4 bg-secondary" onClick={() => handleTrackOrderClick()}>
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="28" height="28" color="#ffffff" fill="none">
									<path d="M12.5 22H10.8889C6.69863 22 4.6035 22 3.30175 20.7447C2 19.4895 2 17.4692 2 13.4286V8H22V10.5" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
									<path d="M18 12C15.7909 12 14 13.8089 14 16.0403C14 17.3163 14.5 18.3083 15.5 19.1945C16.2049 19.8191 17.0588 20.8566 17.5714 21.6975C17.8173 22.1008 18.165 22.1008 18.4286 21.6975C18.9672 20.8733 19.7951 19.8191 20.5 19.1945C21.5 18.3083 22 17.3163 22 16.0403C22 13.8089 20.2091 12 18 12Z" stroke="#ffffff" stroke-width="1.5" stroke-linejoin="round"></path>
									<path d="M18 16H18.009" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
									<path d="M2 8L2.96154 5.69231C3.70726 3.90257 4.08013 3.0077 4.8359 2.50385C5.59167 2 6.56112 2 8.5 2H15.5C17.4389 2 18.4083 2 19.1641 2.50385C19.9199 3.0077 20.2927 3.90257 21.0385 5.69231L22 8" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round"></path>
									<path d="M12 8V2" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round"></path>
									<path d="M10 12H12" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round"></path>
								</svg>
								<span className="text-light hover:text-[#FFB934] capitalize text-sm text-center">Track order</span>
							</div>
						</div>
					</div>

				)} </>
			:
			<div className="w-full border-t-2 px-8 py-2 flex justify-between items-center">
				<p className="lg:mb-0 text-xs">© Copyright 2024</p>
				<div className="flex">
					<a href="#" className="mr-6 hover:text-gray-900 text-xs">Terms of Service</a>
					<a href="#" className="mr-6 hover:text-gray-900 text-xs">Privacy Policy</a>
					<a href="#" className="hover:text-gray-900 text-xs">About Us</a>
				</div>
			</div>}
		</>

	)
}


export default CustomerFooter;